import convertList from '../convertList';
import confGroupMemeber from './confGroupMember';
import discussMember from './discussMember';

function sumTotal(total, item) {
    return total + item.groupList.length;
}

export default function(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        const newList = [];
        confGroupMemeber({
            base: {
                field: 'confGroupMemeber'
            },
            extendConfig: {
                confGroupMemeber: selfConfig
            }
        })
            .then(list => {
                newList.push({
                    id: 0,
                    groupName: '群聊',
                    groupList: list,
                    type: 'group',
                    total: list.reduce(sumTotal, 0),
                    loaded: true
                });

                return discussMember({
                    base: {
                        field: 'discussMember'
                    },
                    extendConfig: {
                        discussMember: selfConfig
                    }
                });
            })
            .then(list => {
                newList.push({
                    id: 1,
                    groupName: '多人聊天',
                    groupList: list,
                    type: 'group',
                    total: list.reduce(sumTotal, 0),
                    loaded: true
                });

                resolve(
                    convertList(
                        newList,
                        {
                            groupName: 'groupName',
                            list: 'groupList'
                        },
                        {
                            groupId: '0',
                            transformGroup(originItem) {
                                const item = originItem;
                                item.loaded = true;
                                return item;
                            }
                        }
                    )
                );
            })
            .catch(err => {
                reject(err);
            });
    });
}
